export const sendible = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm6.121 13.88a1.604 1.604 0 100 3.208 1.604 1.604 0 000-3.208zM7.591 3.964a1.604 1.604 0 100 3.208 1.604 1.604 0 000-3.208zM5.174 6.836c-4.677 5.701-.378 13.519 6.281 13.72h.143a6.064 6.064 0 002.578-.445 2.973 2.973 0 002.007-2.653v-.353a3.149 3.149 0 00-2.183-2.62h-.152c-.73-.184-1.477-.335-2.216-.495a17.219 17.219 0 01-3.25-1.041 5.181 5.181 0 01-3.308-5.315c.007-.259.03-.517.067-.773l.033-.025zM19.97 14.51c1.016-3.687-.689-8.036-4.115-9.564a5.937 5.937 0 00-2.2-.48c-2.082-.058-4.257.63-4.324 3.083v.092a2.52 2.52 0 001.444 2.2 22.773 22.773 0 004.971 1.41c2.217.521 3.594 1.58 4.224 3.259z"
    fill="inherit"
  />
);
